import React, { useState } from 'react';
import { Info, Cable, ListChecks, Map, FileText, Construction } from 'lucide-react';
import { SubModuleLayout } from '../../shared/SubModuleLayout';
import { CablingInformationSection } from './CablingInformationSection';
import { CableTypesSection } from './CableTypesSection';

const Placeholder = ({ title }) => (
  <div
    className="bg-white rounded-lg border border-dashed border-slate-200 py-16 flex flex-col items-center justify-center text-center"
    data-testid={`comm-sc-placeholder-${title.replace(/\s/g, '-').toLowerCase()}`}
  >
    <Construction className="h-8 w-8 text-slate-300 mb-3" />
    <p className="text-sm font-medium text-slate-600">{title}</p>
    <p className="text-xs text-slate-400 mt-1">This module will be configured next.</p>
  </div>
);

/**
 * Structured Cabling top-level tab.
 * Uses the shared hybrid SubModuleLayout (left sub-nav on desktop, dropdown on mobile).
 * Only "Cabling Information" is implemented; the remaining sub-modules are placeholders
 * until their own specs are provided.
 */
export const StructuredCablingSection = ({ projectId, csiItem, canEditCSIItems, canManageProject }) => {
  const [active, setActive] = useState('cabling-info');

  const items = [
    {
      key: 'cabling-info', label: 'Cabling Information', icon: Info,
      content: <CablingInformationSection projectId={projectId} csiItem={csiItem} canEditCSIItems={canEditCSIItems} />,
    },
    { key: 'cable-types', label: 'Cable Types', icon: Cable, content: <CableTypesSection projectId={projectId} csiItem={csiItem} canEditCSIItems={canEditCSIItems} canManageProject={canManageProject} /> },
    { key: 'cabling-schedule', label: 'Cabling Schedule', icon: ListChecks, content: <Placeholder title="Cabling Schedule" /> },
    { key: 'floor-plans', label: 'Floor Plans', icon: Map, content: <Placeholder title="Floor Plans" /> },
    { key: 'submittals', label: 'Submittals', icon: FileText, content: <Placeholder title="Submittals" /> },
  ];

  return <SubModuleLayout items={items} value={active} onValueChange={setActive} testIdPrefix="comm-sc" />;
};
